<div class="docs-section">
  <div class="docs-section__head">
    <h1 class="docs-h1">Changelog</h1>
    <p class="docs-subtitle">What's changed in the Mila Retrieval API.</p>
  </div>

  <div class="docs-empty">
    <p class="docs-empty__title">Nothing published yet.</p>
    <p class="docs-subtitle">Check back after the first API update. Until then, the <a class="link" routerLink="/docs/api-reference">API reference</a> has the current contract for every endpoint.</p>
  </div>
</div>
